import gql from "graphql-tag";

export const USERS_QUERY = gql`
  query {
    users {
      id
      name
      email
      role
      screenOverrides
      externalCorporationId
    }
  }
`;

export const CURRENT_USER_ROLE_QUERY = gql`
  query {
    getCurrentUser {
      id
      role
    }
  }
`;

export const CURRENT_OPERATOR_QUERY = gql`
  query {
    getCurrentAutomationOperator {
      id
      name
    }
  }
`;
